import CryptoJS from 'crypto-js'

export default {
  // 【完全兼容你原来的加密方法】
  Encrypt(data, key, iv) {
    iv = iv || ''
    
    // 关键：和你原来 Node crypto 逻辑 1:1 对齐
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(data),
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    
    return encrypted.toString() // 输出 base64，和你原来完全一样
  },

  // 【完全兼容你原来的解密方法】
  Decrypt(data, key, iv) {
    if (!data) return ''
    iv = iv || ''

    const decrypted = CryptoJS.AES.decrypt(
      data,
      CryptoJS.enc.Utf8.parse(key),
      {
        iv: CryptoJS.enc.Utf8.parse(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )

    return decrypted.toString(CryptoJS.enc.Utf8)
  }
}
